import { Button, Modal, Spinner } from '@components/index';

import { useGetLabelsUsageCount } from './hooks/use-get-labels-usage-count';

type Props = {
  isOpen: boolean;
  labelId: number;
  isDeleting: boolean;
  handleDelete: () => void;
  handleCancel: () => void;
};

export const DeleteLabelModal = ({
  isOpen,
  labelId,
  isDeleting,
  handleDelete,
  handleCancel,
}: Props) => {
  const { instanceCount, isLoading: isloadingInstanceCount } =
    useGetLabelsUsageCount(labelId);

  return (
    <Modal isOpen={isOpen} onClose={handleCancel}>
      <div className="px-6 py-8 w-[620px] flex flex-col gap-2">
        <div className="text-lg font-medium">Delete label</div>
        <div className="flex gap-1 text-gray-8">
          <span>This label is being used in</span>
          <span className="font-semibold flex items-center gap-1">
            {isloadingInstanceCount ? <Spinner /> : instanceCount}
            <span>{instanceCount === 1 ? 'instance' : 'instances'}.</span>
          </span>
          <span>Would you like to proceed?</span>
        </div>
      </div>
      <div className="justify-center flex mb-8 space-x-4">
        <Button
          label="Cancel"
          onClick={handleCancel}
          classOverride="!w-[260px] !border-gray-4 !text-gray-9 !font-medium"
          isDisabled={isDeleting}
        />
        <Button
          label="Yes, Delete label"
          classOverride="!w-[260px] !border-red-3 !bg-red-3 !text-white"
          onClick={handleDelete}
          isDisabled={isDeleting}
          isLoading={isDeleting}
        />
      </div>
    </Modal>
  );
};
